module.exports = __webpack_public_path__ + "img/y2.286580cd.png";